import clone from 'lodash/cloneDeep';
import initialState from '../../store/initialState';
import {
  UPDATE_ROLE_STARTING,
  UPDATE_ROLE_SUCCESS,
  UPDATE_ROLE_ERROR,
} from '../../constants/actionTypes';

export default function updateRoleReducer(state = initialState.updateRole, action) {
  switch (action.type) {
    case UPDATE_ROLE_STARTING: {
      const {roleId} = action;
      const newState = clone(state);

      if (!newState[roleId]) {
        newState[roleId] = clone(initialState.updateRole.roleId);
      }

      const updateData = newState[roleId];
      updateData.saving = true;
      updateData.saved = false;
      updateData.error = null;

      return newState;
    }

    case UPDATE_ROLE_SUCCESS: {
      const {roleId} = action;
      const newState = clone(state);

      if (!newState[roleId]) {
        newState[roleId] = clone(initialState.updateRole.roleId);
      }

      const updateData = newState[roleId];
      updateData.saving = false;
      updateData.saved = true;
      updateData.error = null;
      return newState;
    }

    case UPDATE_ROLE_ERROR: {
      const {roleId} = action;
      const newState = clone(state);

      if (!newState[roleId]) {
        newState[roleId] = clone(initialState.updateRole.roleId);
      }

      const updateData = newState[roleId];
      updateData.saving = false;
      updateData.saved = false;
      updateData.error = action.err;
      return newState;
    }

    default: {
      return state;
    }
  }
}
